import React from "react";
import MacKeyManagementTabs from "./MacKeyManagement/MacKeyManagementTabs";

function MacKeyManagementDashboard(props) {
  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <MacKeyManagementTabs terminalsData={props.terminalsData}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MacKeyManagementDashboard;

